import React, { SVGProps } from 'react';

export default function PauseButtonIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="57"
      height="57"
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <circle cx="28.1428" cy="28.6392" r="28" fill="#0A0E14" />
      <path
        d="M28.1299 53.6392C41.9263 53.6392 53.1428 42.4167 53.1428 28.6392C53.1428 14.8617 41.9263 3.63916 28.1299 3.63916C14.3595 3.63916 3.14282 14.8617 3.14282 28.6392C3.14282 42.4167 14.3595 53.6392 28.1299 53.6392ZM21.0159 38.4736C19.7451 38.4736 19.172 37.8169 19.172 36.8266V20.4204C19.172 19.4301 19.7451 18.7734 21.0159 18.7734H23.4922C24.7476 18.7734 25.3154 19.4301 25.3154 20.4204V36.8266C25.3154 37.8169 24.7476 38.4736 23.4922 38.4736H21.0159ZM32.835 38.4736C31.5902 38.4736 30.9964 37.8169 30.9964 36.8266V20.4204C30.9964 19.4301 31.5902 18.7734 32.835 18.7734H35.3112C36.5354 18.7734 37.1085 19.4301 37.1085 20.4204V36.8266C37.1085 37.8169 36.5354 38.4736 35.3112 38.4736H32.835Z"
        fill="white"
      />
    </svg>
  );
}
